exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*.complementary-container {*/\n/*  color: #0097A78c;*/\n/*  background-color: ghostwhite;*/\n/*  padding: 20px;*/\n/*  text-align: right;*/\n/*}*/\n.form-control {\n  /*color: #0097A7 !important;*/\n}\n.form-control:focus {\n  border-color: #0097A7;\n  box-shadow: 0 0 0 0.2rem rgba(0,151,167,.25);\n}\ninput[type=radio]{\n  position: relative;\n  top: 4px;\n  margin: 38px 10px 0 0;\n}\ninput[type=checkbox]{\n  width: 10px;\n  margin: 10px 32px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/person-info/personInfo.style.css
// module id = 979
// module chunks = 3